<template>
  <div>
    <h3 class="p-4 pt-6 w-full">
      {{ $i18nPresenter.t('Notifications') }}
      <img
        src="@/assets/images/notifications/checks.svg"
        v-tooltip="$i18nPresenter.t('Mark all as read')"
        class="cursor-pointer icon-mark-all"
        @click="markReadAll()"
      >
    </h3>
    <div v-if="!$store.state.notifications.length" class="no-notification">
      <b>{{ $i18nPresenter.t('No notifications yet') }}</b>
      <p>{{ $i18nPresenter.t('Stay tuned for audience feedback, announcements, and more good news.') }}</p>
    </div>
    <div>
      <ul>
        <li
          class="flex noti-item"
          v-for="item in $store.state.notifications"
          :key="item.id"
          @click="readNotification(item)"
        >
          <div class="noti-thumbnail flex-none">
            <div v-if="!item.thumbnail">
              <img src="@/assets/images/notifications/default.svg" v-if="!item.type">
              <img src="@/assets/images/notifications/renew.svg" v-if="item.type === 'renew'">
              <img
                src="@/assets/images/notifications/chat.svg"
                v-if="item.type === 'feedback'"
              >
              <img
                src="@/assets/images/notifications/download-template.svg"
                v-if="item.type === 'download-template'"
              >
              <img
                src="@/assets/images/notifications/share-folder.svg"
                v-if="item.type === 'share-folder'"
              >
              <img
                src="@/assets/images/notifications/share-presentation.svg"
                v-if="item.type === 'share-presentation'"
              >
            </div>
            <img
              :src="item.thumbnail"
              width="40"
              v-if="item.thumbnail"
            >
          </div>
          <div class="noti-content grow">
            <span
              class="status"
              v-if="(!item.NotificationReads || !item.NotificationReads.length) && !item.isRead"
            ></span>
            <h4>{{ item.title }}</h4>
            <p v-if="item.description" :inner-html.prop="item.description | sanitize(item.description)"></p>
            <div>
              <img :src="item.image" v-if="item.image">
            </div>
            <div class="noti-time">
              {{ item.createdAt | dateTimeAgo }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// components
import { mapActions, mapState } from 'vuex'
import NotificationApi from '@/api/notification'
import config from '@/config'
import UserApi from '@/api/user'
import Utils from '@/util'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
  },

  methods: {
    ...mapActions([
    ]),
    async readNotification(item) {
      if (!item.NotificationReads || !item.NotificationReads.length) {
        item.NotificationReads = [{
          id: 1,
        }]
        await NotificationApi.readNotification({
          notificationId: item.id,
        })
      }
      if (item.url) {
        if (item.isNewTab) {
          window.open(item.url)
        } else {
          window.location.href = item.url
        }
      }
      if (item.type === 'feedback' && item.data.presentationId) {
        window.location.href = `${config.presenterDomain}/presentation/${item.data.presentationId}?report=open`
      }
      this._trackEvent('Header > Noti > Click to read', {
        notiUrl: item.url,
        notiDescription: item.description,
      }, item.title)
    },
    async markReadAll() {
      this.$store.state.notifications.forEach((item) => {
        item.isRead = true
      })
      this.$store.state.notifications.push()
      await UserApi.patchUserById(this.currentUser.id, {
        timeMarkReadAllNotification: new Date(),
      })
      this._trackEvent('Header > Noti > Click to read all', {})
    },
    _trackEvent(action, data, event_label = null) {
      Utils.mixpanelTracking(
        this.$route.name,
        action,
        event_label,
        null,
        data,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";

h3 {
  font-size: 20px;
  font-weight: 700;

  img {
    float: right;
  }
}
.noti-thumbnail {
  margin-right: 12px;
  img {
    width: 40px;
  }
}

.noti-item {
  border-bottom: 1px solid #f1f1f1;
  padding: 16px 12px;
  cursor: pointer;

  &:hover {
    background-color: rgb(52 142 246 / 7%);
  }

  h4 {
    font-weight: 600;
    margin-bottom: 4px;
    font-size: 16px;
  }

  p {
    margin-bottom: 12px;
    &::v-deep {
      b {
        font-weight: 600 !important;
      }
    }
  }

  img {
    margin-bottom: 12px;
    border-radius: 4px;
  }

  .noti-time {
    font-size: 12px;
    color: #999999;
  }

  .noti-content {
    position: relative;
    width: 100%;
    padding-right: 12px;

    .status {
      width: 6px;
      height: 6px;
      display: block;
      background-color: #348EF6;
      border-radius: 6px;
      position: absolute;
      top: 6px;
      right: 0;
    }

  }
}

.icon-mark-all {
  padding: 8px 8px;
  margin-top: -8px;
  margin-right: 8px;
  &:hover {
    background-color: #EEF1F6;
    border-radius: 50px;
  }
}

.no-notification {
  text-align: center;
  padding: 0 16px;
  margin-top: 48px;

  b {
    display: block;
    margin-bottom: 12px;
  }
  p {
    font-size: 14px;
    color: #707070;
  }
}
</style>
